import { render, staticRenderFns } from "./FacebookCampaignTableRow.vue?vue&type=template&id=57e54edc"
import script from "./FacebookCampaignTableRow.vue?vue&type=script&lang=js"
export * from "./FacebookCampaignTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports